import React, { Component } from 'react';
import { graphql } from 'react-apollo';
import { compose, mapProps } from 'recompose';
import { withTranslation } from 'react-i18next';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import Tooltip from 'components/common/Tooltip/Tooltip';
import Button from 'components/common/Buttons/Button';
import { isAssessmentReadOnly as isAssessmentReadOnlySelector, getIdFromUrlParams } from 'selectors/assessment/selector';
import { listFieldsState } from 'graphql/operations';
import SubmitTemplateModal from 'components/threepp/assessment/Footer/SubmitTemplateModal';

import './Footer.scss';

export class TemplateFooter extends Component {
  state = {
    showSubmitModal: false
  };

  static propTypes = {
    t: PropTypes.func.isRequired,
    // TODO: Fix this...
    // eslint-disable-next-line react/forbid-prop-types
    template: PropTypes.object.isRequired
  };

  toggleSubmitModal = () => {
    this.setState(prevState => ({ showSubmitModal: !prevState.showSubmitModal }));
  };

  cancelNewRecord = () => {
    window.location.reload(true);
  };

  render() {
    const { t, template, isAssessmentReadOnly, attachmentUploadCount } = this.props;
    const { showSubmitModal } = this.state;

    let submitDisabled = false;
    let disabledReason = '';
    if (isAssessmentReadOnly) {
      submitDisabled = true;
      disabledReason = t('assessment.submit.assessmentReadOnly');
    } else if (attachmentUploadCount > 0) {
      submitDisabled = true;
      disabledReason = t('assessment.submit.uploadAttachment');
      // TODO: This is a temporary solution to enforce that a record must have at least one answered question to be submitted
    } else if (template.metadata.answeredFields < 1) {
      submitDisabled = true;
      disabledReason = t('assessment.submit.atLeastOne');
    }

    return (
      <div className={`assessment-actions template-actions-wrapper ${isAssessmentReadOnly ? 'read-only' : ''}`}>
        <div className="col-sm-8">
          <span className="actions-block">
            <Button className="clear-btn template-btn" buttonStyle="text" onClick={this.cancelNewRecord}>
              {t('assessment.clearAssessment')}
            </Button>
            <Tooltip title={disabledReason}>
              {/* Tooltip requires a non-disabled child */}
              <div>
                <SubmitTemplateModal toggle={this.toggleSubmitModal} isOpen={showSubmitModal} templateId={template.id} recordId={template.recordId} />
                <Button className="submit-btn template-btn" disabled={submitDisabled} buttonStyle="primary" onClick={this.toggleSubmitModal}>
                  {t('assessment.completeAssessment')}
                </Button>
              </div>
            </Tooltip>
          </span>
        </div>
      </div>
    );
  }
}

export const TemplateFooterHOC = compose(
  withRouter,
  withTranslation(),
  graphql(listFieldsState, { name: 'listFieldsState' }),
  mapProps(props => {
    const { template } = props;
    return {
      t: props.t,
      history: props.history,
      template,
      isAssessmentReadOnly: isAssessmentReadOnlySelector(props),
      attachmentUploadCount: props.attachmentUploadCount,
      urlGuid: getIdFromUrlParams(props)
    };
  })
);

export default TemplateFooterHOC(TemplateFooter);
